import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'formChanges',
  pure: false
})
export class FormChangesPipe implements PipeTransform , OnDestroy {
  private _statusSubscription: Subscription;
  private _valueSubscription: Subscription;
  private _control: AbstractControl;
  private _lastValue: any;

  constructor(private _changeDetector: ChangeDetectorRef) {}

  ngOnDestroy() {
    this._dispose();
  }

  transform(obj: any, propertyName?: string): any {
    if(this._control !== obj ){
      this._dispose();
      this._control = obj;
      if(this._control && this._control.statusChanges) {
        this._statusSubscription = this._control.statusChanges.subscribe(() => {
          if(!this.isSame(this._control ? this._control[propertyName] : null)){
            this._changeDetector.markForCheck();
          }
        });
      }
      if(this._control && this._control.valueChanges) {
        this._valueSubscription = this._control.valueChanges.subscribe(() => {
          if(!this.isSame(this._control ? this._control[propertyName] : null)){
            this._changeDetector.markForCheck();
          }
        });
      }
    }
    if(!propertyName) {
      return this._control;
    }
    if(!this.isSame(this._control ? this._control[propertyName] : null)) {
      this._lastValue = this._control ? this._control[propertyName] : null;
      if(Array.isArray(this._lastValue)) {
        this._lastValue = [...this._lastValue];
      }
    }
    return this._lastValue;
  }

  private isSame(value: any): boolean {
    if(Array.isArray(this._lastValue) && Array.isArray(value)){
      if(this._lastValue.length !== value.length){
        return false;
      }
      for(var i =0; i< this._lastValue.length; i++){
        if(this._lastValue[i] !== value[i]){
          return false;
        }
      }
    }
    return this._lastValue === value;
  }

  private _dispose() {
    if(this._statusSubscription) {
      this._statusSubscription.unsubscribe();
    }
    if(this._valueSubscription) {
      this._valueSubscription.unsubscribe();
    }
    this._statusSubscription = null;
    this._valueSubscription = null;
    this._control = null;
    this._lastValue = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/pipes/form-changes.pipe.ts